import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cardrecollectionmodal',
  templateUrl: './cardrecollectionmodal.component.html',
  styleUrls: ['./cardrecollectionmodal.component.css']
})
export class CardrecollectionmodalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
